<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">As Of Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="from_date"/> ~ <CustomDatePicker v-model="to_date"/></span>

				<span class="int_type_no_border mgr_5">
					<PartnerSelect v-model="bill_to_code" ph="Bill To" :showName="false" @set-partner="setPartner" />
				</span>

				<em class="lt_text">Sales Group</em>
				<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="salesGroups" :displayDescription="true" v-model="sales_group_code"/></span>

				<em class="lt_text">Salesman</em>
				<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="reformattedSalesmans" :displayDescription="false" v-model="salesman_id"/></span>

				<em class="lt_text">Payment Term Type</em>
				<span class="int_type_no_border mgr_5">
					<CodeSelectMultiS v-model="payment_term_str" :codes="payment_term_List" :showDesc="false" :width="100" :separator="separator" />
				</span>

				<label> <input ref="chkSummary" type="checkbox" @change="changeTable" /> Summary </label>
			</div>
			<div class="left_option">
				<em class="lt_text">Country</em>
				<span class="int_type_no_border mgr_10">
					<CodeSelect :width="100" :showDesc="false" :codes="countries" v-model="country" />
				</span>

				<em class="lt_text">State</em>
				<span class="int_type_no_border mgr_15"> <CodeSelect :width="100" :codeWidth="120" :showDesc="false" :codes="filteredStates" v-model="state" /> </span>
				<!--
				<em class="lt_text">Option</em>
				<span class="int_type mgr_15">
					<select v-model="payment_term_type" class="tbl_select sm_int">
						<option value="" selected> All</option>
						<option value="C">COD</option>
						<option value="O">OPEN</option>
						<option value="D">COD & OPEN</option>
						<option value="N">Code Outstanding</option>
					</select>
				</span> -->
				<a href="javascript:void(0);" class="search_bt" @click="selectData()">Search</a>
				<a href="javascript:void(0);" class="gray_bt mgr_5" @click="reset()">Reset</a>
				<font color="red"><b>Takes long time without search condition(s) </b></font>
			</div>
		</div>

		<div style="margin: 20px 20px;">
			<table>
				<tr>
					<th class="al_center">Total Amount</th>
					<th class="al_center">Total Receipt Amount</th>
					<th class="al_center">Total Balance</th>
					<th class="al_center">Total Post Amount</th>
					<th class="al_center">Total 0 ~ 30</th>
					<th class="al_center">Total 31 ~ 60</th>
					<th class="al_center">Total 61 ~ 90</th>
					<th class="al_center">Total 91 ~ 120</th>
					<th class="al_center">Total 121 ~ 150</th>
					<th class="al_center">Total 151 ~ 180</th>
					<th class="al_center">Total Over 181</th>
				</tr>
				<tr>
					<td class="al_center">
						<input type="text" class="tbl_int ssm3_int al_right" disabled="disabled" :value="root.total_invoice_amount | toCurrency" />
					</td>
					<td class="al_center">
						<input type="text" class="tbl_int ssm3_int al_right" disabled="disabled" :value="root.total_invoice_amount ? root.total_invoice_amount - root.total_balance_amount : null | toCurrency" />
					</td>
					<td class="al_center">
						<input type="text" class="tbl_int ssm3_int al_right" disabled="disabled" :value="root.total_balance_amount | toCurrency" />
					</td>
					<td class="al_center">
						<input type="text" class="tbl_int ssm3_int al_right" disabled="disabled" :value="root.total_post_check_amount | toCurrency" />
					</td>
					<td class="al_center">
						<input type="text" class="tbl_int ssm3_int al_right" disabled="disabled" :value="root.total_aging_date_0_30 | toCurrency" />
					</td>
					<td class="al_center">
						<input type="text" class="tbl_int ssm3_int al_right" disabled="disabled" :value="root.total_aging_date_31_60 | toCurrency" />
					</td>
					<td class="al_center">
						<input type="text" class="tbl_int ssm3_int al_right" disabled="disabled" :value="root.total_aging_date_61_90 | toCurrency" />
					</td>
					<td class="al_center">
						<input type="text" class="tbl_int ssm3_int al_right" disabled="disabled" :value="root.total_aging_date_91_120 | toCurrency" />
					</td>
					<td class="al_center">
						<input type="text" class="tbl_int ssm3_int al_right" disabled="disabled" :value="root.total_aging_date_121_150 | toCurrency" />
					</td>
					<td class="al_center">
						<input type="text" class="tbl_int ssm3_int al_right" disabled="disabled" :value="root.total_aging_date_151_180 | toCurrency" />
					</td>
					<td class="al_center">
						<input type="text" class="tbl_int ssm3_int al_right" disabled="disabled" :value="root.total_aging_date_181_0 | toCurrency" />
					</td>
				</tr>
			</table>
		</div>

		<div class="fixed-table-container-none-padding">
			<div class="table-wrapper" style="height: 90%">
				<CommonTable
					:tbl_headers="tbl_headers"
					:data="display_records"
					@sort="sort"
					:sort_key="sort_key"
					:sort_direction="sort_direction"
					@selectInvoice="selectInvoice"
					@viewItems="viewItems"
					@updateArMemo="updateArMemo"
					@gotoArHistory="gotoArHistory"
					@gotoPartner="gotoPartner"
				/>
			</div>
		</div>

		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="excel(false)">Excel</a>
				</li>
				<li v-if="company_id == 'jc'">
					<a href="javascript:void(0);" v-on:click="sheet">Sheet</a>
				</li>
				<li>
					<a href="javascript:void(0);" v-on:click="excel(true)">Excel Summary</a>
				</li>
				<li>
					<a href="javascript:void(0);" v-on:click="reportPrint">Print</a>
				</li>
			</ul>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'ViewItems'" :draggable="true">
			<template slot="title">Invoice No : {{ selected_invoice.invoice_dn }} Item(s)</template>
			<template slot="body">
				<SoItemPopup :invoice="selected_invoice" v-on:close="closeModal()" />
			</template>
		</Modal>

		<SheetCopyPopup v-if="sheet_popup" :sheet="sheet_popup" @close="sheet_popup = null" />
	</div>
</template>

<script>
import { apiArBalanceBySalesGroup, apiIndex } from '@/api/report/report';
import CodeSelect from '@/components/common/CodeSelect';
import CodeSelectMultiS from '@/components/common/CodeSelectMultiS';
import { objectToFormData, objectCopy, reportMrtUrl, apiGetReportTemplate, Report, PrintType } from '@/api/util';
import { defaultDataType } from 'export-xlsx';
import { exportDataExcel } from '@/api/util';
import PartnerSelect from '@/components/common/PartnerSelect';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import { today } from '@/utils/date';
import { convertFalsyToEmpty } from '@/utils/etc';
import { apiUpdateArMemo } from '@/api/sales/invoice';
import { addCellStyle } from '@/components/common/commonTable/commonTable.js';
import CommonTable from '@/components/common/commonTable/CommonTable.vue';
import Modal from '@/components/common/Modal';
import SoItemPopup from '@/components/common/SoItemPopup';
import SheetCopyPopup from '@/components/common/SheetCopyPopup';
import _ from 'lodash';

export default {
	data: function() {
		return {
			root: '',
			sales_group_code: '',
			salesGroups: [],
			salesmans: [],
			states: [],
			countries: [],
			country: '',
			state: '',
			bill_to_code: '',
			salesman_id: '',
			receiptTypeList: '',
			receipt_type: '',
			from_date: null,
			to_date: null,
			payment_term_List: [],
			payment_term_str: '',
			separator: ',',
			payment_term_group_list: [],

			sort_key: null,
			sort_direction: null,

			is_summary: false,
			summary_list: [],

			selected_invoice: {},

			modalName: '',
			showModal: false,

			sheet_popup: null, // #3312
		};
	},
	components: {
		CodeSelect,
		CodeSelectMultiS,
		PartnerSelect,
		CustomDatePicker,
		CommonTable,
		Modal,
		SoItemPopup,
		SheetCopyPopup,
	},
	computed: {
		filteredStates: function() {
			if (!this.country && this.user.company_id == 'newjigu') return this.states;

			const vm = this;
			let fStates = this.states.filter(s => s.country === vm.country);
			if (fStates.length === 0) vm.state = null;
			return fStates;
		},
		nullCheckState() {
			return this.state == null ? '' : this.state;
		},
		user: function() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : null;
		},
		isNewjigu() {
			return this.company_id === 'newjigu';
		},
		tbl_headers() {
			if (this.is_summary) return this.summaryHeader();
			else if (this.isNewjigu) return this.newjiguHeader();
			else return this.defaultHeader(); // default
		},
		display_records() {
			let records = null;
			if (this.is_summary) {
				records = [...this.summary_list];
				records.push(this.summaryTotalRow());
			} else if (this.root && Array.isArray(this.root.list)) {
				records = [...this.root.list];
				if (this.isNewjigu) records.push(this.newjiguTotalRow());
				else records.push(this.defaultTotalRow());
			} else {
				records = [];
			}

			return records;
		},
		reformattedSalesmans() {
			// return this.salesmans.map(sm => ({ code: sm.user_id, name: sm.name }));
			if (this.sales_group_code && this.company_id == 'beautyplus') return this.salesmans.filter(sm => sm.sales_group_code == this.sales_group_code).map(sm => ({ code: sm.user_id, name: sm.name }));

			return _.uniqBy(this.salesmans, 'user_id').map(sm => ({ code: sm.user_id, name: sm.name }));
		},
	},
	methods: {
		closeModal() {
			this.showModal = false;
		},
		sort(header) {
			const sort_key = header.key;

			if (this.sort_key == sort_key) {
				this.sort_direction = this.sort_direction == 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				this.sort_direction = 'ASC';
			}
			this.selectData();
		},
		selectInvoice(invoice) {
			if (invoice.invoice_type == 'A') return;
			else if (invoice.invoice_type != 'B' && !invoice.invoice_dn.startsWith('BC')) {
				// this.$router.push({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice.invoice_no } });
				let routeData = this.$router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice.invoice_no } });
				window.open(routeData.href, '_blank');
			}
		},
		viewItems(invoice) {
			this.selected_invoice = invoice;
			this.modalName = 'ViewItems';
			this.showModal = true;
		},
		gotoPartner(invoice) {
			let routeData = this.$router.resolve({ name: 'partnerDetail', params: { mode: 'detail' }, query: { code: invoice.bill_to_code } });
			window.open(routeData.href, '_blank');
		},
		async gotoArHistory(invoice) {
			let routeData = this.$router.resolve({
				name: 'arHistory',
				query: { backUri: this.$route.fullPath, bill_to_code: invoice.bill_to_code, bill_to_name: invoice.bill_to_name, invoice_no: invoice.invoice_no, date_type_is_invoice: '1', all_date: '1', past_days: 90 },
			});
			window.open(routeData.href, '_blank');
		},
		makeDisplayPaymentTerm(payment_term_arr) {
			let display_str = '';
			payment_term_arr.forEach(el => {
				let idx = this.payment_term_List.findIndex(e => e.code === el);
				if (idx > -1) display_str += display_str ? this.separator + this.payment_term_List[idx].name : this.payment_term_List[idx].name;
			});

			return display_str;
		},
		async changeTable() {
			this.$store.commit('setLoading', true);

			const controll_spinner = () => {
				return new Promise(resolve => {
					setTimeout(() => {
						this.is_summary = !this.is_summary;
						resolve();
					}, 500);
				});
			};

			await controll_spinner();
			this.$nextTick(() => this.$store.commit('setLoading', false));
		},
		summaryBySalesGroup() {
			let summary_list = [];

			const searchSGOrder = sales_group_code => {
				let idx = this.salesGroups.findIndex(el => el.code === sales_group_code);
				if (idx < 0) idx = 999999;
				return idx;
			};

			if (this.root.list && Array.isArray(this.root.list)) {
				this.root.list.forEach(el => {
					const idx = summary_list.findIndex(s => s.sales_group_code === el.sales_group_code);
					if (idx > -1) {
						const s = summary_list[idx];
						s.invoice_amount += el.invoice_amount;
						s.invoice_balance += el.invoice_balance;
						s.aging_date_0_30 += el.aging_date_0_30;
						s.aging_date_31_60 += el.aging_date_31_60;
						s.aging_date_61_90 += el.aging_date_61_90;
						s.aging_date_91_0 += el.aging_date_91_0;
						s.aging_date_91_120 += el.aging_date_91_120;
						s.aging_date_121_0 += el.aging_date_121_0;
						s.aging_date_121_150 += el.aging_date_121_150;
						s.aging_date_151_180 += el.aging_date_151_180;
						s.aging_date_181_0 += el.aging_date_181_0;
						s.post_date_amount += el.post_date_amount;
					} else {
						summary_list.push({
							order: searchSGOrder(el.sales_group_code),
							sales_group_code: el.sales_group_code,
							sales_group_name: el.sales_group_name,
							invoice_amount: el.invoice_amount,
							invoice_balance: el.invoice_balance,
							aging_date_0_30: el.aging_date_0_30,
							aging_date_31_60: el.aging_date_31_60,
							aging_date_61_90: el.aging_date_61_90,
							aging_date_91_0: el.aging_date_91_0,
							aging_date_91_120: el.aging_date_91_120,
							aging_date_121_0: el.aging_date_121_0,
							aging_date_121_150: el.aging_date_121_150,
							aging_date_151_180: el.aging_date_151_180,
							aging_date_181_0: el.aging_date_181_0,
							post_date_amount: el.post_date_amount,
						});
					}
				});
			}

			summary_list.sort((a, b) => a.order - b.order);
			summary_list.forEach((el, index) => (el.display_no = index + 1));

			this.summary_list = summary_list;
		},
		async selectData() {
			const payment_term_arr = this.payment_term_str ? this.payment_term_str.split(this.separator) : [];
			const paramObj = {
				sales_group_code: convertFalsyToEmpty(this.sales_group_code),
				receipt_type: convertFalsyToEmpty(this.receipt_type),
				bill_to_code: convertFalsyToEmpty(this.bill_to_code),
				salesman_id: convertFalsyToEmpty(this.salesman_id),
				from_date: convertFalsyToEmpty(this.from_date),
				to_date: convertFalsyToEmpty(this.to_date),
				country: convertFalsyToEmpty(this.country),
				state: convertFalsyToEmpty(this.nullCheckState),
				payment_term_type_arr: payment_term_arr,
				sort_key: convertFalsyToEmpty(this.sort_key),
				sort_direction: convertFalsyToEmpty(this.sort_direction),
			};
			const param = objectToFormData(paramObj);
			const { data } = await apiArBalanceBySalesGroup(param);

			if (data && data.value) {
				data.value.payment_term_code = this.payment_term_str ? this.makeDisplayPaymentTerm(payment_term_arr) : 'ALL';
				if (Array.isArray(data.value.list)) data.value.list.forEach((el, index) => (el.display_no = index + 1));
				if (this.isNewjigu) this.makeNewjiguDisplayList(data.value.list);
			}
			this.root = data.value;
			this.summaryBySalesGroup();
			//console.log(this.root.total_post_check_amount);
		},
		makeNewjiguDisplayList(data_list) {
			if (Array.isArray(data_list)) {
				data_list.forEach(el => {
					if (el.invoice_type !== 'S') el.due_date = null;

					if (el.invoice_type !== 'S' || (0 >= el.invoice_balance && 0 >= el.post_date_amount)) el.aging = null;
					else if (el.past_due_date > 0) addCellStyle(el, 'aging', 'red_letter');

					if (0 >= el.day2) el.day2 = null;
					else if (el.past_due_days2 > 0 && (el.invoice_balance > 0 || el.post_date_amount > 0)) addCellStyle(el, 'day2', 'red_letter');

					if (el.invoice_type == 'S' || el.invoice_type == 'R') el.view_item = 'View';
					else el.view_item = null;
				});
			}
		},
		async index() {
			const { data } = await apiIndex();
			this.salesGroups = data.salesGroupList;
			this.salesmans = data.salesmanList;
			this.states = data.stateList;
			this.countries = data.countryList;
			this.receiptTypeList = data.receiptTypeList;
			this.payment_term_List = data.paymentTermList;
			this.payment_term_group_list = data.paymentTermGroupList;

			if (Array.isArray(this.payment_term_group_list) && this.payment_term_group_list.length > 0) {
				this.payment_term_List.unshift({ name: '─────────────────', code: '', disabled: true });
				this.payment_term_List.unshift(...this.payment_term_group_list);
			}
		},
		async excel(is_summary) {
			let data = is_summary ? this.summary_list : this.root.list;
			const fileName = 'AR_Balance' + (is_summary ? '_Summary' : '');
			let headers = null;

			if (!data || data.length < 1) {
				this.$toast.error('No Data to Export.');
				return false;
			}

			data = objectCopy(data);
			const total = {
				bill_to_code: 'TOTAL',
				bill_to_name: '',
				sales_group_code: 'TOTAL',
				sales_group_name: '',
				invoice_amount: this.root.total_invoice_amount,
				invoice_balance: this.root.total_balance_amount,
				aging_date_0_30: this.root.total_aging_date_0_30,
				aging_date_31_60: this.root.total_aging_date_31_60,
				aging_date_61_90: this.root.total_aging_date_61_90,
				aging_date_91_120: this.root.total_aging_date_91_120,
				aging_date_121_150: this.root.total_aging_date_121_150,
				aging_date_151_180: this.root.total_aging_date_151_180,
				aging_date_181_0: this.root.total_aging_date_181_0,
				post_date_amount: this.root.total_post_check_amount,
				ar_memo: '',
			};

			if (!is_summary) {
				if (!this.isNewjigu) {
					headers = this.defaultExcelHeader();
					data.push(total);
				} else {
					headers = this.newjiguExcelHeader();
					data.unshift(total);
				}
			} else {
				headers = this.summaryExcelHeader();
				data.push(total);
			}

			exportDataExcel(data, headers, fileName);
		},
		// #3312 4차 JC Sheet: 기존 Excel(defaultExcelHeader) 18열의 Invoice Date 다음에 Ship/PickUp Date 를 넣은 19열(고객 첨부 이미지 양식).
		// 기존 Excel 라벨 일부('Invoice Date\t', '91 ~ 120\t')의 탭은 Sheet 헤더에서만 정리하고 기존 Excel 출력은 그대로 둔다.
		sheetHeaders() {
			const headers = this.defaultExcelHeader().map(header => ({ key: header.key, name: header.name.trim(), dataType: header.dataType }));
			const index = headers.findIndex(header => header.key === 'invoice_date');
			headers.splice(index + 1, 0, { key: 'delivery_pick_up_date', name: 'Ship/PickUp Date', dataType: defaultDataType.date });
			return headers;
		},
		// Summary 체크와 무관하게 마지막 조회의 송장 상세 목록(root.list, 화면 정렬 순서)을 합계 행 없이 연다. 조회 전에는 안내만 한다.
		sheet() {
			if (!this.root || !Array.isArray(this.root.list)) {
				this.$toast.error('Please search first');
				return false;
			}
			this.sheet_popup = { title: 'AR Balance By SalesGroup (Sheet)', headers: this.sheetHeaders(), rows: this.root.list };
		},
		async reportPrint() {
			const data = { value: this.root };
			const reportTemplate = await apiGetReportTemplate('ArBalanceBySalesGroup', reportMrtUrl('ArBalanceBySalesGroup'));
			const report = new Report(reportTemplate, data, 'ArBalanceBySalesGroup', PrintType.Normal, false, false, null, 70);
			this.$store.commit('setReport', report);
		},
		setPartner(partner) {
			this.bill_to_code = partner.code;
		},
		reset() {
			this.state = '';
			this.country = '';
			this.bill_to_code = '';
			this.sales_group_code = '';
			this.payment_term_str = '';

			this.sort_key = null;
			this.sort_direction = null;

			this.from_date = '01-01-2000';
			this.to_date = today();
		},
		defaultHeader() {
			return [
				{ key: 'display_no', name: 'No', tbl_width: '2%', td_class: 'al_center' },
				{ key: 'bill_to_code', name: 'Bill To', tbl_width: '5%', td_class: ['truncate'], th_click_event: 'sort', title: { prop: 'bill_to_code' }, click_event: 'gotoPartner' },
				{ key: 'bill_to_name', name: 'Bill To Name', td_class: ['truncate'], th_click_event: 'sort', title: { prop: 'bill_to_name' }, click_event: 'gotoPartner' },
				{ key: 'sales_group_code', name: 'S.G.', tbl_width: '3%', td_class: ['truncate'], th_click_event: 'sort', title: { prop: 'sales_group_name' } },
				{ key: 'address_state', name: 'State', tbl_width: '3%', td_class: ['truncate', 'al_center'], th_click_event: 'sort', title: { prop: 'address_state' } },
				{ key: 'invoice_date', name: 'Invoice Date', tbl_width: '5%', td_class: 'al_center', th_click_event: 'sort' },
				{ key: 'invoice_dn', name: 'Invoice No', tbl_width: '7%', td_class: 'al_center', th_click_event: 'sort', click_event: 'selectInvoice' },
				{ key: 'ar_memo', name: 'AR Memo', tbl_width: '5%', th_click_event: 'sort', input_type: 'text', title: { prop: 'ar_memo' } },
				{ key: 'ar_memo_upd', name: 'Upd.', tbl_width: '3%', td_class: 'al_center', button_info: { display: 'Upd.', class: 'gray_bt', click_event: 'updateArMemo' } },
				{ key: 'payment_term_name', name: 'Method', tbl_width: '5%', td_class: ['al_center', 'truncate'], th_click_event: 'sort', title: { prop: 'payment_term_name' } },
				{ key: 'invoice_amount', name: 'Invoice Amount', tbl_width: '5%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency' },
				{ key: 'invoice_balance', name: 'Balance', tbl_width: '5%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency', click_event: 'gotoArHistory' },
				{ key: 'aging_date_0_30', name: '0 ~ 30', tbl_width: '5%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency' },
				{ key: 'aging_date_31_60', name: '31 ~ 60', tbl_width: '5%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency' },
				{ key: 'aging_date_61_90', name: '61 ~ 90', tbl_width: '5%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency' },
				{ key: 'aging_date_91_120', name: '91 ~ 120', tbl_width: '5%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency' },
				{ key: 'aging_date_121_150', name: '121 ~ 150', tbl_width: '5%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency' },
				{ key: 'aging_date_151_180', name: '151 ~ 180', tbl_width: '5%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency' },
				{ key: 'aging_date_181_0', name: 'OVER 181', tbl_width: '5%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency' },
				{ key: 'post_date', name: 'Post Date', tbl_width: '5%', td_class: 'al_center', th_click_event: 'sort' },
				{ key: 'post_date_amount', name: 'Post Amt.', tbl_width: '5%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency' },
			];
		},
		defaultExcelHeader() {
			return [
				{ key: 'bill_to_code', name: 'Bill To', width: 15, dataType: defaultDataType.string },
				{ key: 'bill_to_name', name: 'Bill To Name', width: 25, dataType: defaultDataType.string },
				{ key: 'sales_group_name', name: 'Sales Group', width: 15, dataType: defaultDataType.string },
				{ key: 'address_state', name: 'State', width: 10, dataType: defaultDataType.string },
				{ key: 'invoice_date', name: 'Invoice Date	', width: 15, dataType: defaultDataType.string },
				{ key: 'invoice_dn', name: 'Invoice No', width: 15, dataType: defaultDataType.string },
				{ key: 'payment_term_name', name: 'Method', width: 15, dataType: defaultDataType.string },
				{ key: 'invoice_amount', name: 'Invoice Amount', width: 15, dataType: defaultDataType.number },
				{ key: 'invoice_balance', name: 'Balance', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_0_30', name: '0 ~ 30', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_31_60', name: '31 ~ 60', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_61_90', name: '61 ~ 90', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_91_120', name: '91 ~ 120	', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_121_150', name: '121 ~ 150', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_151_180', name: '151 ~ 180', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_181_0', name: 'OVER 181', width: 15, dataType: defaultDataType.number },
				{ key: 'post_date', name: 'Post Date', width: 15, dataType: defaultDataType.string },
				{ key: 'post_date_amount', name: 'Post Amt', width: 15, dataType: defaultDataType.number },
			];
		},
		defaultTotalRow() {
			return {
				is_colspan_record: true,
				columns: [
					{ colspan: 10, key: 'display_no', display_no: 'Grand Total', td_class: ['al_right'] },
					{ colspan: 1, key: 'invoice_amount', invoice_amount: this.root.total_invoice_amount, display_filter: 'toCurrency', td_class: ['al_right'] },
					{ colspan: 1, key: 'invoice_balance', invoice_balance: this.root.total_balance_amount, display_filter: 'toCurrency', td_class: ['al_right'] },
					{ colspan: 1, key: 'aging_date_0_30', aging_date_0_30: this.root.total_aging_date_0_30, display_filter: 'toCurrency', td_class: ['al_right'] },
					{ colspan: 1, key: 'aging_date_31_60', aging_date_31_60: this.root.total_aging_date_31_60, display_filter: 'toCurrency', td_class: ['al_right'] },
					{ colspan: 1, key: 'aging_date_61_90', aging_date_61_90: this.root.total_aging_date_61_90, display_filter: 'toCurrency', td_class: ['al_right'] },
					{ colspan: 1, key: 'aging_date_91_120', aging_date_91_120: this.root.total_aging_date_91_120, display_filter: 'toCurrency', td_class: ['al_right'] },
					{ colspan: 1, key: 'aging_date_121_150', aging_date_121_150: this.root.total_aging_date_121_150, display_filter: 'toCurrency', td_class: ['al_right'] },
					{ colspan: 1, key: 'aging_date_151_180', aging_date_151_180: this.root.total_aging_date_151_180, display_filter: 'toCurrency', td_class: ['al_right'] },
					{ colspan: 1, key: 'aging_date_181_0', aging_date_181_0: this.root.total_aging_date_181_0, display_filter: 'toCurrency', td_class: ['al_right'] },
					{ colspan: 1, key: 'post_date', post_date: '' },
					{ colspan: 1, key: 'post_date_amount', post_date_amount: this.root.total_post_check_amount, display_filter: 'toCurrency', td_class: ['al_right'] },
				],
			};
		},
		newjiguHeader() {
			return [
				{ key: 'display_no', name: 'No', tbl_width: '2%', td_class: 'al_center' },
				{ key: 'bill_to_code', name: 'Bill To', tbl_width: '5%', td_class: ['truncate'], th_click_event: 'sort', title: { prop: 'bill_to_code' }, click_event: 'gotoArHistory' },
				{ key: 'bill_to_name', name: 'Bill To Name', td_class: ['truncate'], th_click_event: 'sort', title: { prop: 'bill_to_name' }, click_event: 'gotoPartner' },
				{ key: 'sales_group_code', name: 'S.G.', tbl_width: '2%', td_class: ['truncate'], th_click_event: 'sort', title: { prop: 'sales_group_name' } },
				{ key: 'address_state', name: 'Terr', tbl_width: '2%', td_class: ['truncate', 'al_center'], th_click_event: 'sort' },
				{ key: 'invoice_date', name: 'Invoice Date', tbl_width: '5%', td_class: 'al_center', th_click_event: 'sort' },
				{ key: 'invoice_dn', name: 'Invoice No', tbl_width: '5%', td_class: 'al_center', th_click_event: 'sort', click_event: 'selectInvoice' },
				{ key: 'view_item', name: 'Item(s)', tbl_width: '3%', td_class: 'al_center', th_click_event: '', click_event: 'viewItems' },
				{ key: 'payment_term_name', name: 'Method', tbl_width: '5%', td_class: ['al_center', 'truncate'], th_click_event: 'sort', title: { prop: 'payment_term_name' } },
				{ key: 'due_date', name: 'Due Date', tbl_width: '5%', td_class: 'al_center', th_click_event: 'sort' },
				{ key: 'aging', name: 'Day1', tbl_width: '3%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'commaSeparated' },
				{ key: 'invoice_amount', name: 'Invoice Amt.', tbl_width: '5%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency' },
				{ key: 'invoice_balance', name: 'Balance', tbl_width: '5%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency', click_event: 'gotoArHistory' },
				{ key: 'post_date', name: 'Post Date', tbl_width: '5%', td_class: 'al_center', th_click_event: 'sort' },
				{ key: 'day2', name: 'Day2', tbl_width: '3%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'post_date_amount', name: 'Post Amt.', tbl_width: '5%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency' },
				{ key: 'aging_date_0_30', name: '0 ~ 30', tbl_width: '5%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency' },
				{ key: 'aging_date_31_60', name: '31 ~ 60', tbl_width: '5%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency' },
				{ key: 'aging_date_61_90', name: '61 ~ 90', tbl_width: '5%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency' },
				{ key: 'aging_date_91_120', name: '91 ~ 120', tbl_width: '5%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency' },
				{ key: 'aging_date_121_0', name: 'OVER 121', tbl_width: '5%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency' },
				{ key: 'ar_memo', name: 'AR Memo', tbl_width: '7%', th_click_event: 'sort', input_type: 'text', title: { prop: 'ar_memo' } },
				{ key: 'ar_memo_upd', name: 'Upd.', tbl_width: '3%', td_class: 'al_center', button_info: { display: 'Upd.', class: 'gray_bt', click_event: 'updateArMemo' } },
			];
		},
		newjiguExcelHeader() {
			return [
				{ key: 'bill_to_code', name: 'Bill To', width: 12, dataType: defaultDataType.string },
				{ key: 'bill_to_name', name: 'Bill To Name', width: 25, dataType: defaultDataType.string },
				{ key: 'sales_group_name', name: 'S.G.', width: 7, dataType: defaultDataType.string },
				{ key: 'address_state', name: 'Terr', width: 7, dataType: defaultDataType.string },
				{ key: 'invoice_date', name: 'Inv Date', width: 12, dataType: defaultDataType.string },
				{ key: 'invoice_dn', name: 'Inv No', width: 15, dataType: defaultDataType.string },
				{ key: 'payment_term_name', name: 'Method', width: 15, dataType: defaultDataType.string },
				{ key: 'due_date', name: 'Due Date', width: 12, dataType: defaultDataType.string },
				{ key: 'aging', name: 'Day1', width: 7, dataType: defaultDataType.currency },
				{ key: 'invoice_amount', name: 'Inv Amt', width: 15, dataType: defaultDataType.number },
				{ key: 'invoice_balance', name: 'Balance', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_0_30', name: '0 ~ 30', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_31_60', name: '31 ~ 60', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_61_90', name: '61 ~ 90', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_91_120', name: '91 ~ 120	', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_121_150', name: '121 ~ 150', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_151_180', name: '151 ~ 180', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_181_0', name: 'OVER 181', width: 15, dataType: defaultDataType.number },
				{ key: 'post_date', name: 'Post Date', width: 12, dataType: defaultDataType.string },
				{ key: 'day2', name: 'Day2', width: 7, dataType: defaultDataType.currency },
				{ key: 'post_date_amount', name: 'Post Amt', width: 15, dataType: defaultDataType.number },
				{ key: 'ar_memo', name: 'AR Memo', width: 25, dataType: defaultDataType.string },
			];
		},
		newjiguTotalRow() {
			return {
				is_colspan_record: true,
				columns: [
					{ colspan: 10, key: 'display_no', display_no: 'Grand Total', td_class: ['al_right'] },
					{ colspan: 1, key: 'invoice_amount', invoice_amount: this.root.total_invoice_amount, display_filter: 'toCurrency', td_class: ['al_right'] },
					{ colspan: 1, key: 'invoice_balance', invoice_balance: this.root.total_balance_amount, display_filter: 'toCurrency', td_class: ['al_right'] },
					{ colspan: 1, key: 'post_date', post_date: '' },
					{ colspan: 1, key: 'day2', day2: '' },
					{ colspan: 1, key: 'post_date_amount', post_date_amount: this.root.total_post_check_amount, display_filter: 'toCurrency', td_class: ['al_right'] },
					{ colspan: 1, key: 'aging_date_0_30', aging_date_0_30: this.root.total_aging_date_0_30, display_filter: 'toCurrency', td_class: ['al_right'] },
					{ colspan: 1, key: 'aging_date_31_60', aging_date_31_60: this.root.total_aging_date_31_60, display_filter: 'toCurrency', td_class: ['al_right'] },
					{ colspan: 1, key: 'aging_date_61_90', aging_date_61_90: this.root.total_aging_date_61_90, display_filter: 'toCurrency', td_class: ['al_right'] },
					{ colspan: 1, key: 'aging_date_91_120', aging_date_91_120: this.root.total_aging_date_91_120, display_filter: 'toCurrency', td_class: ['al_right'] },
					{ colspan: 1, key: 'aging_date_121_0', aging_date_121_0: this.root.total_aging_date_121_0, display_filter: 'toCurrency', td_class: ['al_right'] },
					{ colspan: 1, key: 'ar_memo', ar_memo: '' },
					{ colspan: 1, key: 'ar_memo_upd', ar_memo_upd: '' },
				],
			};
		},
		summaryHeader() {
			return [
				{ key: 'display_no', name: 'No', tbl_width: '3%', td_class: 'al_center' },
				{ key: 'sales_group_code', name: 'Sales Group Code', tbl_width: '7%', td_class: ['truncate'] },
				{ key: 'sales_group_name', name: 'Sales Group Name', tbl_width: '10%', td_class: ['truncate'] },
				{ key: 'invoice_amount', name: 'Invoice Amount', tbl_width: '8%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'invoice_balance', name: 'Balance', tbl_width: '8%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'aging_date_0_30', name: '0 ~ 30', tbl_width: '8%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'aging_date_31_60', name: '31 ~ 60', tbl_width: '8%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'aging_date_61_90', name: '61 ~ 90', tbl_width: '8%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'aging_date_91_120', name: '91 ~ 120', tbl_width: '8%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'aging_date_121_150', name: '121 ~ 150', tbl_width: '8%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'aging_date_151_180', name: '151 ~ 180', tbl_width: '8%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'aging_date_181_0', name: 'OVER 181', tbl_width: '8%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'post_date_amount', name: 'Post Amt.', tbl_width: '8%', td_class: 'al_right', display_filter: 'toCurrency' },
			];
		},
		summaryExcelHeader() {
			return [
				{ key: 'sales_group_code', name: 'Sales Group Code', width: 15, dataType: defaultDataType.string },
				{ key: 'sales_group_name', name: 'Sales Group Name', width: 15, dataType: defaultDataType.string },
				{ key: 'invoice_amount', name: 'Invoice Amount', width: 15, dataType: defaultDataType.number },
				{ key: 'invoice_balance', name: 'Balance', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_0_30', name: '0 ~ 30', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_31_60', name: '31 ~ 60', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_61_90', name: '61 ~ 90', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_91_120', name: '91 ~ 120	', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_121_150', name: '121 ~ 150', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_151_180', name: '151 ~ 180', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_181_0', name: 'OVER 181', width: 15, dataType: defaultDataType.number },
				{ key: 'post_date_amount', name: 'Post Amt', width: 15, dataType: defaultDataType.number },
			];
		},
		summaryTotalRow() {
			return {
				is_colspan_record: true,
				columns: [
					{ colspan: 3, key: 'display_no', display_no: 'Grand Total', td_class: ['al_right'] },
					{ colspan: 1, key: 'invoice_amount', invoice_amount: this.root.total_invoice_amount, display_filter: 'toCurrency', td_class: ['al_right'] },
					{ colspan: 1, key: 'invoice_balance', invoice_balance: this.root.total_balance_amount, display_filter: 'toCurrency', td_class: ['al_right'] },
					{ colspan: 1, key: 'aging_date_0_30', aging_date_0_30: this.root.total_aging_date_0_30, display_filter: 'toCurrency', td_class: ['al_right'] },
					{ colspan: 1, key: 'aging_date_31_60', aging_date_31_60: this.root.total_aging_date_31_60, display_filter: 'toCurrency', td_class: ['al_right'] },
					{ colspan: 1, key: 'aging_date_61_90', aging_date_61_90: this.root.total_aging_date_61_90, display_filter: 'toCurrency', td_class: ['al_right'] },
					{ colspan: 1, key: 'aging_date_91_120', aging_date_91_120: this.root.total_aging_date_91_120, display_filter: 'toCurrency', td_class: ['al_right'] },
					{ colspan: 1, key: 'aging_date_121_150', aging_date_121_150: this.root.total_aging_date_121_150, display_filter: 'toCurrency', td_class: ['al_right'] },
					{ colspan: 1, key: 'aging_date_151_180', aging_date_151_180: this.root.total_aging_date_151_180, display_filter: 'toCurrency', td_class: ['al_right'] },
					{ colspan: 1, key: 'aging_date_181_0', aging_date_181_0: this.root.total_aging_date_181_0, display_filter: 'toCurrency', td_class: ['al_right'] },
					{ colspan: 1, key: 'post_date_amount', post_date_amount: this.root.total_post_check_amount, display_filter: 'toCurrency', td_class: ['al_right'] },
				],
			};
		},
		async init() {
			this.reset();
			await this.index();
		},

		async updateArMemo(invoice) {
			const { data } = await apiUpdateArMemo(invoice);
			if (data.result) {
				this.$toast.success('Updated successfully');
			} else {
				this.$toast.error('Failed');
			}
		},
	},
	mounted() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_arBalanceBySalesGroup');
		this.$store.commit('setSubTitle', 'Report -> AR Balance By SalesGroup');

		this.init();
	},
};
</script>

<style scoped></style>
